// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdvancedSearchController from "./advanced_search_controller"
application.register("advanced-search", AdvancedSearchController)

import ArtistTagsController from "./artist_tags_controller"
application.register("artist-tags", ArtistTagsController)

import ArtworkTagsController from "./artwork_tags_controller"
application.register("artwork-tags", ArtworkTagsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import PerPageSelectorController from "./per_page_selector_controller"
application.register("per-page-selector", PerPageSelectorController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)

